import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CountdownTimer, CountdownTimerStyles } from '../../../models/countdown-timer';

@Component({
  selector: 'lib-right-sidebar-editor',
  templateUrl: './right-sidebar-editor.component.html',
  styleUrls: ['./right-sidebar-editor.component.scss']
})
export class RightSidebarEditorComponent implements OnChanges {
  @Input() data: CountdownTimer;

  @Output() handleSubmit = new EventEmitter();
  @Output() handleFormValid = new EventEmitter();

  public bindingStylesData: CountdownTimerStyles;

  constructor() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.bindingStylesData = { ...changes.data.currentValue.styles };
    }
  }

  onStylesSubmit($event) {
    this.handleSubmit.emit($event);
  }

  onStylesValid($event) {
    this.handleFormValid.emit($event);
  }
}
